// Brand surfaces use the same neutral palette in every saved app theme.
// Warning/destructive colors are inherited so their meaning is preserved.
export function neutralColors(colors, dark) {
  const ink = dark ? '#FFFFFF' : '#040404';
  const secondary = dark ? '#B3B3B3' : '#616161';
  const surface = dark ? '#1C1C1C' : '#FFFFFF';
  const inset = dark ? '#282828' : '#F5F5F5';
  const line = dark ? '#383838' : '#E5E5E5';
  return {
    ...colors,
    solid_color_primary: surface,
    solid_color_block: surface,
    solid_color_secondary: inset,
    solid_color_secondary_dark: dark ? '#383838' : '#E5E5E5',
    solid_color_tertiary: inset,
    solid_color_tooltip: '#1C1C1C',
    text_color_primary: ink,
    text_color_secondary: secondary,
    text_color_tertiary: secondary,
    text_color_link: ink,
    border_color: line,
    border_color_primary: '#808080',
    border_color_secondary: line,
    accent_color_primary: ink,
    accent_text_color: dark ? '#040404' : '#FFFFFF',
    color_success: ink,
  };
}
